import React from "react";
import Header from "@/components/Header";
import Head from "next/head";
import { generateNextSeo } from "next-seo/pages";
import PrivacyPolicy from "@/components/PrivacyPolicy";
import Footer from "@/components/Footer";

export default function PrivacyPolicyPage() {
  return (
    <div className="">
      <Head>
        {generateNextSeo({
          title: "Privacy Policy",
          description:
            "Learn how Uptime Monitor protects your privacy and handles your data. We are committed to maintaining the confidentiality and security of your information.",
          canonical: "https://uptime-monitor.io/privacy_policy",
          openGraph: {
            title: "Privacy Policy - Uptime Monitor",
            description: "Understand how we collect, use, and protect your data at Uptime Monitor.",
            url: "https://uptime-monitor.io/privacy_policy",
          },
        })}
      </Head>
      <div>
        <Header />

        <PrivacyPolicy />

        <Footer />
      </div>
    </div>
  );
}
